module.exports = __webpack_public_path__ + "media/application/images/svgs/star-0a8c2f72ac3df53223df201fa96b2b81.svg";